export const headerLayoutOptions = [
  { value: 'logo-left', label: 'Logo on the left' }
  // { value: 'logo-center', label: 'Logo on the center' }
]
export const headerStyleOptions = [
  { value: 'solid', label: 'Solid' },
  { value: 'transparent', label: 'Transparent' }
]
